import React from "react";
import styled from "styled-components";

const Header = styled.h1`
    margin-bottom: 24px;
    color: #57614e;
`;

const AppHeader = (props) => (
    <Header>
        {props.children}
    </Header>
);

export default AppHeader;